import React from 'react';
import { Instagram, Mail, MapPin, MessageCircle } from 'lucide-react';
import { BRAND_NAME, BRAND_TAGLINE, contact, navItems, whatsappUrl } from '../data/site';
export function Footer() {
  return <footer className="w-full bg-forest-deep pt-20 text-ivory sm:pt-24" data-id="element-95" data-mp="32onll67cnuaj">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-96" data-mp="36p6d0z5byyc7">
        <div className="grid gap-14 lg:grid-cols-3" data-id="element-97" data-mp="36nd6djupwe47">
          <div data-id="element-98" data-mp="3ues7xaeo6ree">
            <p className="font-serif text-2xl tracking-[0.18em]" data-id="element-99" data-mp="3ugbrb9vmhike">{BRAND_NAME}</p>
            <p className="mt-4 font-serif text-xl italic text-gold-soft" data-id="element-100" data-mp="38z70lzg0p09">
              {BRAND_TAGLINE}
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-101" data-mp="3le2l2w7e0bct">
            <p className="text-[11px] font-semibold uppercase tracking-wider-xl text-ivory/45" data-id="element-102" data-mp="3qd6sbhar3z0i">
              Explore
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3.5" data-id="element-103" data-mp="29y5l8cy0g70t">
              {navItems.map(item => <li key={item.label} data-id="element-104" data-mp="2ezuvvrhbmiod">
                  <a href={item.href} className="text-[15px] text-ivory/70 transition-colors duration-300 hover:text-gold-soft" data-id="element-105" data-mp="3l9k65dxrvpdt">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-106" data-mp="3q8wphopfqebn">
            <p className="text-[11px] font-semibold uppercase tracking-wider-xl text-ivory/45" data-id="element-107" data-mp="3q8djn6d27gdz">
              Contact
            </p>
            <ul className="mt-6 space-y-3.5 text-[15px] text-ivory/70" data-id="element-108" data-mp="81fpbv4sgq3o">
              <li className="flex items-center gap-3" data-id="element-109" data-mp="32w1tqajr697">
                <MapPin className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-110" data-mp="323053qg36xx" />
                {contact.location}
              </li>
              <li data-id="element-111" data-mp="ct783jhpdrj9">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft" data-id="element-112" data-mp="cus3fbbudei6">
                  <MessageCircle className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-113" data-mp="tv4iroyaqfyo" />
                  {contact.whatsapp}
                </a>
              </li>
              <li data-id="element-114" data-mp="yupii1laiscg">
                <a href={`mailto:${contact.email}`} className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft" data-id="element-115" data-mp="ys3bc32baeur">
                  <Mail className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-116" data-mp="18m3sx4es5ckd" />
                  {contact.email}
                </a>
              </li>
              <li data-id="element-117" data-mp="1hjw888ki4k7r">
                <a href="#book" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft" data-id="element-118" data-mp="1hje1uj44kpm4">
                  <Instagram className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-119" data-mp="1rjemq9hn7dsf" />
                  {contact.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-ivory/12 py-8 text-[12px] text-ivory/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-120" data-mp="3t9q7m4km9oum">
          <p data-id="element-121" data-mp="2ah86ezuq5gx3">© 2026 {BRAND_NAME}</p>
          <p className="pb-14 sm:pb-0" data-id="element-122" data-mp="25nviyt1s7g5x">
            Placeholder website — content, photography and rates to be confirmed.
          </p>
        </div>
      </div>
    </footer>;
}